import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Toast, ToastContainer, Spinner } from "react-bootstrap";
import ModalCloseIcon from "../../assets/svg/close-modal.svg";
import { getReportIssueTypeApi, reportAnIssueApi } from "./common-api";
import "./report-an-issue.css";
const ReportAnIssueModal = ({ onSuccess, onCancel }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [validations, setvalidations] = useState({
    description: "",
    title: "",
    type: "",
  });
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 10000,
    },
    modal: {
      backgroundColor: "#ffffff",

      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "680px",

      overflowY: "auto",
    },
  };
  useEffect(() => {
    getReportIssueType();
  }, []);
  const [selectedStatus, setSelectedStatus] = useState("pending");
  const [rejectReason, setRejectReason] = useState("");
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("");
  const [title, setTitle] = useState("");
  const [issueTypeList, setIssueTypeList] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastStatus, setToastStatus] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const getReportIssueType = async () => {
    const response = await getReportIssueTypeApi();
    if (response.success === true) {
      const list = response.data ?? [];
      setIssueTypeList(list);
      if (list.length > 0) {
        setSelectedStatus(list[0].label);
      }
    } else {
    }
  };
  const reportIssue = async () => {
    setIsSubmitting(true);
    const payload = {
      application: "Dock",
      type: selectedStatus,
      title: title,
      description: rejectReason,
    };
    try {
      const response = await reportAnIssueApi(payload);
      if (response.status === 400) {
        setvalidations({
          description: response.data.error?.description?.[0] || "",
          title: response.data.error?.title?.[0] || "",
          type: response.data.error?.type?.[0] || "",
        });
      } else {
        if (response.data.success === true) {
          setToastMessage(response.data.message || "Report submitted successfully!");
          setToastStatus(true);
          setShowToast(true);
          // Reset form
          setTitle("");
          setRejectReason("");
          setSelectedStatus("pending");
          setvalidations({ description: "", title: "", type: "" });
          // Close modal after delay
          setTimeout(() => {
            onSuccess(response.data);
          }, 1500);
        } else {
          setToastMessage(response.data.message || "Failed to submit report");
          setToastStatus(false);
          setShowToast(true);
        }
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={modalStyle.overlay}>
      <div
        style={{
          ...modalStyle.modal,
          borderRadius: "24px",
          width: "720px",
          position: "relative",
        }}
      >
        {/* Header */}
        <div className="modal-header-container">
          <h2 className="modal-title-text">Report a problem</h2>
          <div
            onClick={onCancel}
            style={{
              cursor: "pointer",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src={ModalCloseIcon} alt="Close" style={{ width: "24px", height: "24px" }} />
          </div>
        </div>

        {/* Content */}
        <div className="report-issue-modal-body text-start">
          {/* Issue Type */}
          <div className="issue-type-label">Issue Type</div>
          <div className="radio-group">
            {issueTypeList.map((type, index) => (
              <div key={index} className={`custom-radio-pill ${selectedStatus === type.label ? "active" : ""}`} onClick={() => setSelectedStatus(type.label)}>
                <div className="radio-circle">
                  <div className="radio-inner-dot"></div>
                </div>
                <span>{type.label}</span>
              </div>
            ))}
          </div>
          {validations.type && <div className="text-danger fs-12 mb-2">{validations.type}</div>}

          {/* Title */}
          <div className="form-field-label">
            Title<span className="required-star">*</span>
          </div>
          <input type="text" className="custom-input" placeholder="Enter here" value={title} onChange={(e) => setTitle(e.target.value)} />
          {validations.title && <div className="text-danger fs-12 mt-1">{validations.title}</div>}

          {/* Description */}
          <div className="form-field-label">
            Explain your problem<span className="required-star">*</span>
          </div>
          <textarea className="custom-textarea" placeholder=" " value={rejectReason} onChange={(e) => setRejectReason(e.target.value)} />
          {validations.description && <div className="text-danger fs-12 mt-1">{validations.description}</div>}

          {/* Actions */}
          <div className="actions-container">
            <button className="btn-cancel" onClick={onCancel}>
              Cancel
            </button>
            <button className="btn-submit" onClick={reportIssue} disabled={isSubmitting} style={{ cursor: isSubmitting ? "not-allowed" : "pointer" }}>
              {isSubmitting ? (
                <>
                  <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                </>
              ) : (
                "Send report"
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Toast Notification */}
      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
        <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide bg={toastStatus === true ? "success" : "danger"}>
          <Toast.Body className="text-white">{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default ReportAnIssueModal;
